import axios from "#/net/axios.js";
import { Toast } from 'vant-ui'

//
import { getShopStaticResouceUrl, } from "#/utils/common.js"
import distribution from "./distribution.json"

/**
 * vuex
 */
const state = {
    distribution: distribution,
}

const getters = {

}

const mutations = {
    setDescription(state, data) {
        //
        state.distribution = data;
    },
}

const actions = {
    fetchDistribution({ commit }) {
        axios.
            static_resource.get('data/distribution.json', null, {
                'Cache-Control': 'no-cache'
            })
            .then(data => {
                // handle success
                commit('setDescription', data)
            }).catch((error) => {
                // handle error
                Toast(`获取配送配置文件出错, ${error.toString()}`)
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
